import { render } from "./FileUploadList.vue?vue&type=template&id=70cf47f6"
import script from "./FileUploadList.vue?vue&type=script&lang=js"
export * from "./FileUploadList.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__